import React, {useState} from 'react';
import { useDispatch, useSelector } from "react-redux";
import { addBulkFavourites, removeFavourite } from "../../store/features/slice-account";

import Section from "../Section";
import Loading from "../Loading";
import Image from '../Image';
import { ReactComponent as StarIcon } from '../../assets/images/icons/star.svg';
import { ReactComponent as StarSolidIcon } from '../../assets/images/icons/star_solid.svg';




const SingleInfo = (props) => {

    const dispatch = useDispatch();
    const [isFavouriteOp, setIsFavouriteOp] = useState(false);
    const accountData = useSelector((state) => state.account.data);

    const handleAddFavourite = () => {
        setIsFavouriteOp(true);
        dispatch(addBulkFavourites({doctors: [props.slug], skip_loading: true})).then(e => {
            setIsFavouriteOp(false);
        })
    }

    const handleRemoveFavourite = () => {
        setIsFavouriteOp(true);
        dispatch(removeFavourite({doctor: props.slug})).then(e => {
            setIsFavouriteOp(false);
        })
    }

    const classPrefix = props.classPrefix ? props.classPrefix : 'doctor-single'

    return (
        <Section className={`${classPrefix}--info`}>
            {props.image ?  
                <Image 
                    className={`${classPrefix}--figure`}
                    src={props.image}
                    alt={props.title}
                />
            : null}
            <div className={`${classPrefix}--title`}>
                <h1 className={`${classPrefix}--name`}>{props.title}</h1>
                <h3 className={`${classPrefix}--postnominals`}>{props.postNominals}</h3>
                {props.tags && props.tags.length > 0 ? 
                    <div className={`${classPrefix}--tags`}>
                        {/* {props.tags.map((tag, index) => {
                            return <div className="text text--tag bold" key={index}>
                                        {tag.name}
                                    </div>
                        })} */}
                        <div className="text text--tag bold">
                            {props.tags[0].name}
                        </div>
                    </div>
                : null}
                {accountData ? 
                    <div className={`${classPrefix}--favourite`}>
                        {isFavouriteOp ? <Loading /> : 
                        accountData.favourites.includes(props.slug) ? 
                            <>
                                <div className={`${classPrefix}--favourite-tooltip solid`}>
                                    Remove from favourites
                                </div>
                                <StarSolidIcon className="icon-solid" onClick={handleRemoveFavourite} />
                            </>
                            : <>
                                <div className={`${classPrefix}--favourite-tooltip`}>
                                    Add as favourite
                                </div>
                                <StarIcon className="icon-outline" onClick={handleAddFavourite} />
                            </>
                        }
                    </div>
                : null}
            </div>
        </Section>
    );
};

export default SingleInfo;